import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Transition as _Transition, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-body" }
const _hoisted_2 = { class: "app-header" }
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navigation = _resolveComponent("Navigation")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Socials = _resolveComponent("Socials")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass('app page-' + $setup.pathName)
  }, [
    _createVNode(_component_Navigation),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: $setup.socials.github + '.png?size=320',
              alt: "",
              width: "320"
            }, null, 8, _hoisted_3)
          ]),
          _: 1
        }),
        _createVNode(_component_Socials)
      ]),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          _createVNode(_component_router_view, { class: "app-content" })
        ]),
        _: 1
      })
    ])
  ], 2))
}